/*
 * @Author: songxiaoqiang
 * @Date: 2020-08-10 11:33:26
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import utils from "../../../utils/utils";
import "./App.css";
import { initPti, uploadTrack } from "shihuo-lib/dist/shihuo-lib";
import { callAppTrigger, pageShowTrack } from "../../../utils/callAppLib";
import NavigationBar from './baseComponents/navigation-bar';
import NavigationBarPopover from './baseComponents/navigation-bar-popover';
import PipelineComment from './baseComponents/comment';
import allComponents from 'comp'
import { interveneTest } from '../../../utils/interveneTest'
const isDev = process.env.NODE_ENV === 'development'

const baseConfig = isDev ? require('./config/base-config-test') : require('./config/base-config')
const mycomponents = isDev ? require('./config/components-test') : require('./config/components')

const TEMPLATE_NAME = 'zhuanti'
const pageId = utils.getPageId() || '';
const isCommunityTab = utils.getParams('community_tab') == '1';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.exp = typeof window !== "undefined" && window.shihuo ? new window.shihuo.Exposure() : null;
    const {
      title,
      shareTitle,
      shareContent,
      shareImg,
      navigatorBarTranslucent,
      navigatorBarTheme,
      searchBoxDisplay,
      searchWords,
      searchGuideText,
      searchGuideColor,
      abTestEnable,
      abPreviewValue,
      abPercent,
      ruleEntryShow,
      ruleEntryHref,
      dataSourceStr = "",
      createTime = ""
    } = (typeof window !== "undefined" && !isDev ? window : baseConfig);
    const shareUrl = typeof window !== "undefined" && window.location.href.replace('zt-public.shihuo.cn', 'm.shihuo.cn/zt-public')
    const shareInfo = {
      shareUrl: shareUrl || "https://m.shihuo.cn",
      shareTitle: shareTitle || title || "来自识货App的分享",
      shareContent: shareContent || "识货App：实物鉴别，严选正品优质店铺，购物之前要识货",
      shareImage: shareImg || "http://static.shihuocdn.cn/admin/files/20200701/802cc61ad724a6f194befc52a80807ea.jpeg",
    }
    const isShihuo = utils.isShihuo();
    const isAndroid = utils.isAndroid();

    let pipelineComponents =
      typeof window !== "undefined"
        ? window.INIT_DATA || mycomponents
        : mycomponents;

    let abValue = ''
    
    if (abTestEnable == '是' && typeof window !== 'undefined') {

      let isPipelineAbExist = false;
      // 先判断页面中是否存在AB实验的组件，只有存在AB实验的组件时再进行流量分配
      for (const comp of pipelineComponents) {
        if (comp.name === 'pipeline-ab') {
          isPipelineAbExist = true;
          break;
        }
        if (comp.name === 'pipeline-tabItem') {
          for (const tabItemcomp of comp.data) {
            if (tabItemcomp.name === 'pipeline-ab') {
              isPipelineAbExist = true;
              break;
            }
          }
        }
      }

      if (isPipelineAbExist) {
        if (['lego-api.shihuo.cn', 'lego-api-tst.shihuo.cn'].indexOf(window.location.host) >= 0) { // 代表是预览环境
          abValue = abPreviewValue
        } else {
          const cacheKey = `pipeline_ab_${pageId}`
          const abCacheValue = localStorage.getItem(cacheKey)
          const abPercentCacheKey = `ab_percent_${pageId}`
          const abPercentCacheValue = localStorage.getItem(abPercentCacheKey)
          if (abCacheValue && abPercentCacheValue == abPercent) {
            abValue = abCacheValue
          } else {
            const arr = [{
              value: 'A',
              percent: abPercent
            }, {
              value: 'B',
              percent: 100 - abPercent
            }]
            const randomItem = utils.getWeightRandom(arr)       
            abValue = randomItem.value
            localStorage.setItem(cacheKey, abValue)
            localStorage.setItem(abPercentCacheKey, abPercent)
          }
        }
      }
    }

    const downloadUrl =
      typeof window !== "undefined"
        ? {
            ios: window.iphone_url,
            android: window.android_url,
          }
        : {
            ios: baseConfig.iphone_url,
            android: baseConfig.android_url,
          };

    let from = typeof window !== "undefined" ? window.from : baseConfig.from;

    // 从链接获取下载链接和kolid
    if (typeof window !== "undefined" && utils.getParams("longurl")) {
      let longurl = utils.getParams("longurl");
      longurl = decodeURIComponent(longurl);
      const queryArray = longurl.split("?")[1].split("&");
      const queryObj = {};
      queryArray.forEach((item) => {
        const itemObj = item.split("=");
        queryObj[itemObj[0]] = itemObj[1];
      });
      // 取出longurl上的参数作为配置数据
      from = queryObj.from;
      downloadUrl.ios = queryObj.iphone_url;
      downloadUrl.android = queryObj.android_url;
    }

    // 从url中获取口令参数，默认为空
    let kouling = "";
    if (typeof window !== "undefined" && utils.getQueryString("kl")) {
      kouling = utils.getQueryString("kl");
      kouling = decodeURIComponent(kouling);
    }

    const backgroundColor = typeof window !== "undefined" ? window.backgroundColor : baseConfig.backgroundColor

    const baseComponents = {}
    const basePipelineComponents = []

    let navigationBarPaddingTop = 0
    let navigationBarHeight = 0

    const allModals = JSON.parse(JSON.stringify(pipelineComponents.filter(item => item.name === 'pipeline-modal')))
    const autoModals = allModals.filter(item => {
      if (typeof window !== "undefined" && item.data.baseConfig.triggerType === '进页面唤起') {
        const times = +(window.localStorage.getItem(item.id) || 0)
        const popTimes = item.data.baseConfig.popTimes
        if (times < popTimes || popTimes === '') {
          return true
        }
      }
      return false
    }).sort((a, b) => a.data.baseConfig.level < b.data.baseConfig.level ? -1 : 1)

    if (isShihuo && navigatorBarTranslucent === '是' && !isCommunityTab) {
      baseComponents['navigation-bar'] = NavigationBar
      basePipelineComponents.push({
        id: "navigation-bar",
        name: "navigation-bar",
        data: {
          baseConfig: {
            navigatorBarTheme,
            searchBoxDisplay,
            searchWords,
            searchGuideText,
            searchGuideColor,
            ...shareInfo
          }
        }
      });
    }

    this.state = {
      pipelineComponents: [
        ...pipelineComponents,
        ...basePipelineComponents
      ],
      autoModals,
      allModals,
      goodsList: [],
      components: {
        ...allComponents,
        ...baseComponents
      },
      from: from,
      downloadUrl: `http://www.shihuo.cn/shihuo/qrcodeRedirect?iphone_url=${downloadUrl.ios}&android_url=${downloadUrl.android}&from=${from}`,
      kouling,
      navigationBarHeight,
      navigationBarPaddingTop,
      backgroundColor,
      dataSourceStr,
      routeParams: null,
      abValue: abValue,
      navigatorBarTheme: '黑',
      webpSupport: true,
      osVersion: '',
      createTime,
      playerState: '',
      ruleEntryShow,
      ruleEntryHref,
      lotteryState: false,
      communityVoteState: false,
      group: ''
    };
    this.scrollTime = "";
    this.isScrolling = false;
    this.scrollTimeout = null;
    this.pageVisiable = true;

    this.iframe = utils.getParams('isIframe') == '1';
    this.isShihuo = isShihuo;
    this.isAndroid = isAndroid;
    this.kouling = kouling;
    this.shareInfo = shareInfo;
    this.isWx = typeof window !== "undefined" ? window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' : false
    this.isQQ = typeof window !== "undefined" ? (/MQQBrowser/i.test(window.navigator.userAgent) && /\sQQ/i.test((window.navigator.userAgent).split('MQQBrowser'))) : false
    this.isWeibo =  typeof window !== "undefined" ? window.navigator.userAgent.toLowerCase().match(/WeiBo/i) == 'weibo' : false
    this.hideCallAppBtn = utils.getParams('hideCallAppBtn');
  }

  async componentWillMount() {
    if (typeof window !== "undefined") {
      this.querySupportWebp();
    }
  }

  async componentDidMount() {
    if (typeof window !== "undefined") {

      if (this.isShihuo) {
        
        window.Jockey.send("getRouteParams", {}, (value) => {
          let { components, pipelineComponents } = this.state
          let { navigatorBarTranslucent, navigatorBarTheme, commentEnable, searchBoxDisplay, searchWords, searchGuideText, searchGuideColor } = (isDev ? baseConfig : window)
          let navigationBarPaddingTop = 0, navigationBarHeight = 0;
  
          window.Jockey.send('setStatusbarStyle', {
            barStyle: navigatorBarTheme === '黑' ? 'dark-content' : 'light-content'
          });

          // 如果是在华为智慧搜素或华为生活服务App打开，则不显示沉浸式导航
          if (window.HW_MANAGED_JS || (window.lives && typeof window.lives.getAppExists == 'function')) {
            navigatorBarTranslucent = '否';
          }
          
          if (value && (value.navigationBar === 'false' || value.navigationBar === false) && value.openType !== 'modal' && value.modalStyle !== 'popOver' && navigatorBarTranslucent == '是') {
            const navigationBarInfo = utils.getNavigationBarInfo();
            if (navigationBarInfo) {
              navigationBarPaddingTop = navigationBarInfo.navigationBarPaddingTop;
              navigationBarHeight = navigationBarInfo.navigationBarHeight;
            }
      
            if (isCommunityTab) {
              navigationBarHeight = 0;
              navigationBarPaddingTop = 0;
            }
          }

          if (value && value.openType === 'modal' && value.modalStyle === 'popOver') {
  
            navigationBarPaddingTop = 0;
            navigationBarHeight = 48;
  
            // 页面通过原生弹板形式打开
            components['navigation-bar-popover'] = NavigationBarPopover;
            pipelineComponents.unshift({
              id: "navigation-bar-popover",
              name: "navigation-bar-popover",
              data: {
                baseConfig: {
                  navigatorBarTheme,
                  searchBoxDisplay,
                  searchWords,
                  searchGuideText,
                  searchGuideColor,
                  ...this.shareInfo
                }
              }
            });

            // 过滤掉常规沉浸式导航
            pipelineComponents = pipelineComponents.filter(item => item.name !== 'navigation-bar');
          }

          if (utils.SHDiffVersion(utils.getVersion(), '7.72.0') && commentEnable === '是') {
            // v7.72.0及以上版本 才能展示评论区
            components['comment'] = PipelineComment;
            pipelineComponents.push({
              id: 'comment',
              name: 'comment',
              data: {}
            });
          }
          this.setState({
            routeParams: value,
            navigatorBarTheme,
            navigationBarPaddingTop,
            navigationBarHeight,
            pipelineComponents,
            components
          });
        });

      } else {

        if (this.isAndroid && this.isWx) {
          // 安卓微信浏览器中，加载微信JSSDK
          await utils.loadWeixinJsSdk();
          // 站外访问埋点
          pageShowTrack('h5Lego:show:', {
            kouling: this.kouling,
            lego_page_id: pageId,
            legoAb: this.state.abValue
          });
          const timeout = setTimeout(() => {
            this.loadWxOpenLaunchAppTag();
            clearTimeout(timeout);
          }, 500);
        }

        const { components, pipelineComponents } = this.state;
        const { commentEnable } = (isDev ? baseConfig : window);
        if (commentEnable === '是') {
          components['comment'] = PipelineComment;
          pipelineComponents.push({
            id: 'comment',
            name: 'comment',
            data: {}
          });
        }
        this.setState({
          components,
          pipelineComponents
        });
      }

      if (!this.isAndroid) {
        document.documentElement.style.overscrollBehavior = 'none';
        document.body.style.overscrollBehavior = 'none';
      }
    }

    this.registerShare();

    this.communityTabLogic();
    
    window.Jockey.send("hideNavigationBar",()=>{});
  }

  componentWillUnmount() {}

  // 加载微信开放标签
  loadWxOpenLaunchAppTag = () => {
    if (window.WxOpenLaunchApp) {
      const { navigatorBarTranslucent } = (isDev ? baseConfig : window);
      const pathname = window.location.pathname.replace('/zt-public', '');
      const href = encodeURIComponent('https://zt-public.shihuo.cn' + pathname);
      const targetUrl = `shihuo://www.shihuo.cn?route=fastWebview&url=${href}&navigationBar=${navigatorBarTranslucent !== '是'}`;
      const pageOptions = {
        lego_page_id: pageId,
        legoAb: this.state.abValue
      }
      const commonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 10001,
        width: '100%',
        height: '100%'
      }
      const { shareTitle, shareContent, shareImage, shareUrl } = this.shareInfo;
      const shareInfo = {
        title: shareTitle,
        desc: shareContent,
        imgUrl: shareImage,
        link: shareUrl
      }
      const wxOpenLaunchApp = new window.WxOpenLaunchApp({
        options: {
          targetUrl,
          kouling: this.kouling,
          scene: 'h5Lego',
          shareInfo,
          pageOptions
        },
        containers: [
          {
            element: '.open-app',
            style: commonStyle,
            clickEvent: () => {
              const kouling = typeof window !== "undefined" && `1http://shihuo.cn${this.kouling}##${window.localStorage.getItem('m_device_id')}##h5Lego`;
              uploadTrack({
                pti: {
                  id: "lego:goApp",
                  name: '',
                  biz: JSON.stringify({
                    lego_page_id: pageId,
                    legoAb: this.state.abValue,
                    h5Url: window.location.href,
                    pageId: pageId,
                    command:  kouling,
                    deviceId: window.localStorage.getItem('m_device_id')
                  }),
                  pageOptions: {
                    lego_page_id: pageId,
                    legoAb: this.state.abValue
                  }
                },
              });
            }
          }
        ]
      });
      // 初始化配置
      wxOpenLaunchApp.initConfig();
    }
  }

  // 页面初始化埋点及iframe通信
  handleExtraEvent = () => {
    // 页面进入埋点
    if (typeof window !== 'undefined') {
      initPti({
        pageName: pageId
      });
      const pageOptions = {
        lego_page_id: pageId,
        h5Url: window.location.href,
        legoAb: this.state.abValue
      }
      uploadTrack(
        {
          pti: {
            id: 'lego-specialTopic:show',
            name: '',
            biz: JSON.stringify(pageOptions),
            pageOptions: pageOptions
          },
        }
      )

      // 页面停留时长埋点上报
      utils.pageStayTrack('lego-specialTopic', pageOptions);
    }

    // 在iframe中打开，获取组件尺寸并发送后台编辑器
    if (typeof window !== 'undefined' && window.parent && this.iframe) {
      utils.postComponentSizeToEditor();
    }
  }

  // 注册分享
  registerShare = () => {
    /**
     * 分享到微信内页面域名使用www.shihuo.cn,因为微信开档标签域名只支持www.shihuo.cn，
     * nginx会将www.shihuo.cn/zt-public转发到zt-public.shihuo.cn,
     * app内则正常使用zt-public.shihuo.cn域名
     */
    if (typeof window !== 'undefined') {
      window.Jockey.send("register:share", {
        url: this.shareInfo.shareUrl,
        title: this.shareInfo.shareTitle,
        content: this.shareInfo.shareContent,
        img: this.shareInfo.shareImage,
      }); 
    }
  }

  // 社区Tab场景特殊逻辑
  communityTabLogic = () => {
    if (typeof window !== "undefined" && isCommunityTab) {
      const timer = setTimeout(() => {
        const pageOptions = {
          lego_page_id: pageId,
          h5Url: window.location.href,
          legoAb: this.state.abValue
        }
        window.Jockey.on("onPageVisibleStateChange", (e) => {
          if(e && e.pageState === 'visible' && e.appState === 'foreground') {
            const jumpSubPage = localStorage.getItem('jumpSubPage');
            if (jumpSubPage) {
              localStorage.removeItem('jumpSubPage')
            } else {
              // 上报埋点
              uploadTrack(
                {
                  pti: {
                    id: `lego-specialTopic:show`,
                    name: '',
                    biz: JSON.stringify(pageOptions),
                    pageOptions: pageOptions
                  },
                }
              )
            }
            if (this.state.pipelineComponents.find(comp => comp.name === 'pipeline-video' || comp.name === 'pipeline-interactMessage')) {
              // 播放视频
              this.setState({
                playerState: 'play'
              });
            }
            this.pageVisiable = true;
            // 页面可见时，重置页面停留开始时间
            localStorage.setItem('stayStart', String(new Date().getTime()));
          } else {
            // 上报埋点
            if (this.state.pipelineComponents.find(comp => comp.name === 'pipeline-video' || comp.name === 'pipeline-interactMessage')) {
              // 暂停播放
              this.setState({
                playerState: 'pause'
              }); 
            }
            // 页面隐藏时，停留时长埋点上报
            if (this.pageVisiable) {
              this.pageVisiable = false;
              utils.pageStayUpload('lego-specialTopic', pageOptions)
            }
          }
        });
        window.Jockey.send("onPageVisibleStateChange", {}, () => {});

        clearTimeout(timer);
      }, 1000);
    }
  }

  querySupportWebp = () => {
    window.Jockey.send("device", async(device) => {
      if (device) {
        const platform = device.platform;
        const osVersion = device.os_version || '';
        const deviceId = device.idfa || device.deviceId;
        const osMainVersion = Number(osVersion.split('.')[0]);

        const abtest_tag = device.abtest_tag;
        let group = '';
        abtest_tag.split(';').forEach(item => {
          if (item && item.indexOf('BG=') > -1) {
            const value = item.split('=')[1]
            group = value == 3 ? 'B' : 'A';
          }
        });

        let pipelineComponents = JSON.parse(JSON.stringify(this.state.pipelineComponents));
        if (['17675052474380033'].includes(pageId)) {
          pipelineComponents = interveneTest(pipelineComponents, pageId, group);
        }

        if (platform === 'ios' && osMainVersion < 14) {
          this.setState({
            webpSupport: false,
            osVersion,
            group,
            legoAb: group,
            pipelineComponents
          }, () => {
            this.handleExtraEvent();
          });
        } else {
          this.setState({
            webpSupport: true,
            osVersion,
            group,
            abValue: group,
            pipelineComponents
          }, () => {
            this.handleExtraEvent();
          });
        } 

        if (window.aegis) {
          window.aegis.setConfig({
            uin: deviceId
          });
        }
      }
    });
  }

  // 在APP内查看详情
  handleBrowserInApp = () => {
    const kouling = typeof window !== "undefined" && `1http://shihuo.cn${this.kouling}##${window.localStorage.getItem('m_device_id')}##h5Lego`;
    uploadTrack({
      pti: {
        id: "lego:goApp",
        name: '',
        biz: JSON.stringify({
          lego_page_id: pageId,
          legoAb: this.state.abValue,
          h5Url: typeof window !== "undefined" && window.location.href,
          pageId: pageId,
          command:  kouling,
          deviceId: typeof window !== "undefined" && window.localStorage.getItem('m_device_id')
        }),
        pageOptions: {
          lego_page_id: pageId,
          legoAb: this.state.abValue
        }
      },
    });
    const { navigatorBarTranslucent } = (isDev ? baseConfig : window);
    let pathname, href;
    if (typeof window !== "undefined") {
      if (['lego-api.shihuo.cn', 'lego-api-tst.shihuo.cn'].indexOf(window.location.host) >= 0) {
        href = window.location.href;
      } else {
        pathname = window.location.pathname.replace('/zt-public', '');
        href = encodeURIComponent('https://zt-public.shihuo.cn' + pathname);
      }
    }
    let targetUrl = `shihuo://www.shihuo.cn?route=fastWebview&url=${href}&navigationBar=${navigatorBarTranslucent !== '是'}`;
    const pageOptions = {
      template: 'lego-specialTopic'
    }
    callAppTrigger(targetUrl, this.kouling, 'h5Lego', pageOptions);
  }

  ruleEntryJump = (href) => {
    window.Jockey.send('action', {
      url: href
    });
  }

  // 更新社区投票状态
  updateCommunityVoteState = (status) => {
    this.setState({
      communityVoteState: status
    });
  }

  // 更新社区活动抽奖状态
  updateLotteryState = (status) => {
    this.setState({
      lotteryState: status
    });
  }

  // 在App内查看详情按钮
  renderBrowserInApp() {
    if (typeof window !== 'undefined' && window.parent && this.iframe) {
      // 在iframe中打开，不展示在App内查看详情按钮
      return null;
    }
    if (['16721084081180003', '17144598318590047', '17060774329760034', '16969957160610015', '16926141014140017', '16799015532440085', '16890597986400025', '17248335524800036', '17097071136750084'].indexOf(pageId) >= 0) {
      return null;
    }
    return (
      <div className="open-app">
        <img
          src={utils.formatImgUrl('https://static.shihuocdn.cn/admin/files/20220313/c1247a0d14f693b5d1a18820132752da.png')}
          alt=""
          className="btn"
          onClick={() => this.handleBrowserInApp()}
        />
      </div>
    )
  }

  render() {
    const { from = "", downloadUrl = "", kouling = "", routeParams, navigationBarHeight = 0, navigationBarPaddingTop = 0, navigatorBarTheme = "黑", backgroundColor = "", abValue, autoModals = [], allModals = [], dataSourceStr = '', osVersion = '', createTime = '', ruleEntryShow, ruleEntryHref, lotteryState, communityVoteState } = this.state;
    const navList = [];
    let hasNavigation = false;

    this.state.pipelineComponents.forEach((item, idx) => {

      if (item.name === 'pipeline-modal') {
        // 将组件名置空，不进行渲染，在allModals统一处理
        item.name = ''
        return
      }

      if (item.name == 'pipeline-ab') {
        // if (!abValue || typeof window == 'undefined') {
        //   // 将组件名置空，不进行渲染
        //   item.name = ''
        //   return
        // }
        const list = item.data || []
        list.forEach(comp => {
          if (comp.id.endsWith(`TEST_${abValue}`)) {
            this.state.pipelineComponents[idx] = comp
            item = comp
          }
        })
      }

      if (item.name && item.id && !item.blockName) {
        item.blockName = item.id
        let json = null
        try {
          json = require(`comp/${item.name}/package.json`)
        } catch (e) {
          console.log('not found')
        }
        if (json && json.pipeline) {
          item.blockName += `-${json.pipeline.title}`
          if (item.data && item.data.baseConfig && item.data.baseConfig.title) {
            item.blockName += `_${item.data.baseConfig.title}`
          }
        }
      }
      if (
        ([
          'pipeline-product', 
          'pipeline-goodsRecommend',
          'pipeline-rank',
          'pipeline-imgHotMap',
          'pipeline-community',
          'pipeline-communityArticle',
          'pipeline-pkRank',
          'pipeline-product-customize',
          'pipeline-productCollection',
          'pipeline-productGather',
          'pipeline-productLayout3',
          'pipeline-hotSellRankList'
        ].includes(item.name)) &&
          item.data &&
          item.data.baseConfig &&
          item.data.baseConfig.addToNav &&
          item.data.baseConfig.title
      ) {
        navList.push({
          id: item.id,
          title: item.data.baseConfig.title
        });
      }
      if (item.name === 'pipeline-imgList' &&
        item.data &&
        item.data.baseConfig &&
        item.data.baseConfig.addToNav &&
        item.data.baseConfig.title
      ) {
        navList.push({
          id: item.id,
          title: item.data.baseConfig.title
        });
      }
      if(item.name == 'pipeline-navigation'){
        hasNavigation = true
      }
    });

    if (autoModals[0]) {
      autoModals[0].visible = true
    }

    const allComponents = this.state.pipelineComponents.concat(autoModals)

    const Components = allComponents.map((oneComponent, index) => {
      const OneComponent = this.state.components[oneComponent.name];

      const otherProps = {
        templatePti: 'lego-specialTopic',
        allComponents: allComponents,
        baseAllComponents: this.state.components,
        legoAb: abValue,
        osVersion: osVersion,
        isLastComponent: index === allComponents.length - 1,
        playerState: this.state.playerState,
        createTime: createTime,
        exp: this.exp
      }
      if (typeof window !== "undefined" && (window.HW_MANAGED_JS || (window.lives && typeof window.lives.getAppExists == 'function'))) {
        Object.assign(otherProps, {
          specialApiFrom: 'huawei'
        });
      }
      if (oneComponent.name === 'pipeline-modal') {
        otherProps.visible = oneComponent.visible
        otherProps.onClose = () => {
          autoModals.splice(0, 1)
          setTimeout(() => {
            this.setState({ autoModals })           
          }, 200)
        }
      }

      const { componentSize } = oneComponent.data;
      const containerStyle = {};
      // if (componentSize && componentSize.height !== "" && FixedHeightComps.indexOf(oneComponent.name) >= 0 && !this.iframe) {
      //   Object.assign(containerStyle, {
      //     minHeight: oneComponent.name != 'pipeline-navigation' ? px2rem(`${componentSize.height}px`) : px2rem('40px')
      //   })
      //   if (oneComponent.name === 'pipeline-imgHotMap' && oneComponent.data.baseConfig.isFixedBottom) {
      //     Object.assign(containerStyle, {
      //       minHeight: ''
      //     });
      //     // typeof window !== "undefined" && (document.querySelector("#root").style.paddingBottom = '54px');
      //   }
      // }

      return OneComponent && (
        <div className="component-wrapper" style={{...containerStyle}} key={`OneComponent-${index}`}>
          <OneComponent
            componentIndex={index}
            componentLength={this.state.pipelineComponents.length}
            key={oneComponent.id}
            from={from}
            downloadUrl={downloadUrl}
            kouling={kouling}
            navList={navList}
            hasNavigation={hasNavigation}
            customAttributes={{
              "data-component-id": oneComponent.id,
              "data-component-name": oneComponent.name,
              "data-component-block": oneComponent.blockName,
            }}
            config={oneComponent.data}
            dataSourceStr={dataSourceStr}
            navigatorBarTheme={navigatorBarTheme}
            navigationBarHeight={navigationBarHeight}
            navigationBarPaddingTop={navigationBarPaddingTop}
            routeParams={routeParams}
            webpSupport={this.state.webpSupport}
            backgroundColor={backgroundColor}
            templateName={TEMPLATE_NAME}
            allModals={allModals}
            componentSize={componentSize}
            lotteryState={lotteryState}
            communityVoteState={communityVoteState}
            designIntent={oneComponent.designIntent}
            updateLotteryState={this.updateLotteryState}
            updateCommunityVoteState={this.updateCommunityVoteState}
            {...otherProps}
            exp={(ele) => {
              if (ele) {
                this.exp.add({ el: ele });
              }
            }}
          />
        </div>
      );
    });
 
    return (
      
      <div className="App">
        {
          typeof window !== "undefined"
            && window.document.documentElement
              && window.document.documentElement.getAttribute('style')
                && Components
        }
        {
          ruleEntryShow === '是' && (
            <div className="rule-entry-area" style={{top: navigationBarHeight + 4}} onClick={() => this.ruleEntryJump(ruleEntryHref)}>
              <p>活动规则</p>
            </div>
          )
        }
        {!this.isShihuo && this.hideCallAppBtn != '1' && this.renderBrowserInApp()}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./templates/zhuanti/src/App.js